// import { BuilderComponent, builder } from "@builder.io/react";

// const BUILDER_API_KEY = "67d9d228858940769676d22fc3acbd7b";

// builder.init(BUILDER_API_KEY);

// export default function BuilderPage({ url }) {
//   return (
//     <BuilderComponent model="page" url={url} />
//   );
// }





import { BuilderComponent, builder, useIsPreviewing } from '@builder.io/react';
import { useState, useEffect } from 'react';


builder.init("67d9d228858940769676d22fc3acbd7b");

export default function BuilderPage({url}) {
  const [builderContent, setBuilderContent] = useState(null);
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const isPreviewing = useIsPreviewing();

  useEffect(() => {

    const urlPath = url

 
    builder
      .get('page', { 
        url: urlPath,
        includeRefs: true 
      })
      .promise()
      .then(content => {
        setBuilderContent(content);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching Builder content:', err);
        setLoading(false);
      });


    fetch('https://dummyjson.com/products')
      .then(res => res.json())
      .then(data => {
        setApiData(data.products[0]); // Get first 5 posts
      })
      .catch(err => {
        console.error('Error fetching API data:', err);
      });
  }, []);


  if (loading) {
    return <div>Loading...</div>;
  }


  if (!builderContent && !isPreviewing) {
    return <div>Page not found</div>;
  }

  console.log(apiData,"datatatattata")


  return (
    <BuilderComponent 
      model="page" 
      content={builderContent}
       data={{ items: apiData }}
    />
  );
}
